import { render, staticRenderFns } from "./SimpleNumberView.vue?vue&type=template&id=78cfd592&scoped=true&"
import script from "./SimpleNumberView.vue?vue&type=script&lang=js&"
export * from "./SimpleNumberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cfd592",
  null
  
)

export default component.exports